import { render, staticRenderFns } from "./NoActivePolls.vue?vue&type=template&id=7385e100&scoped=true"
import script from "./NoActivePolls.vue?vue&type=script&lang=js"
export * from "./NoActivePolls.vue?vue&type=script&lang=js"
import style0 from "./NoActivePolls.vue?vue&type=style&index=0&id=7385e100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7385e100",
  null
  
)

export default component.exports